import { useEffect, useRef, useState } from "react";
import "./PhotographyCreative.css";

// ============================================
// IMAGES
// Apni actual images ke imports yahan lagana
// ============================================

import peopleImg from "../../assets/Balanoor.png";
import portraitsImg from "../../assets/Balanoor.png";
import spacesImg from "../../assets/Balanoor.png";
import productsImg from "../../assets/Balanoor.png";
import foodImg from "../../assets/Balanoor.png";
import creativeImg from "../../assets/Balanoor.png";

import peopleGrid1 from "../../assets/Balanoor.png";
import peopleGrid2 from "../../assets/Balanoor.png";
import peopleGrid3 from "../../assets/Balanoor.png";

import portraitsGrid1 from "../../assets/Balanoor.png";
import portraitsGrid2 from "../../assets/Balanoor.png";
import portraitsGrid3 from "../../assets/Balanoor.png";

import spacesGrid1 from "../../assets/Balanoor.png";
import spacesGrid2 from "../../assets/Balanoor.png";
import spacesGrid3 from "../../assets/Balanoor.png";

import productsGrid1 from "../../assets/Balanoor.png";
import productsGrid2 from "../../assets/Balanoor.png";
import productsGrid3 from "../../assets/Balanoor.png";

import foodGrid1 from "../../assets/Balanoor.png";
import foodGrid2 from "../../assets/Balanoor.png";
import foodGrid3 from "../../assets/Balanoor.png";

import creativeGrid1 from "../../assets/Balanoor.png";
import creativeGrid2 from "../../assets/Balanoor.png";
import creativeGrid3 from "../../assets/Balanoor.png";

import CinematicChapterPage from "./CinematicChapterPage";
// ============================================
// CHAPTER DATA
// ============================================

const chapters = [
  {
    number: "01",
    title: "SET LIFE",
    description: "Real individuals.",
    description2: "Unfiltered stories.",
    image: peopleImg,
    side: "left",

    grid: [
      peopleGrid1,
      peopleGrid2,
      peopleGrid3,
    ],
  },

  {
    number: "02",
    title: "THE PORTRAIT GALLERY",
    description: "Every expression",
    description2: "tells a story.",
    image: portraitsImg,
    side: "right",

    grid: [
      portraitsGrid1,
      portraitsGrid2,
      portraitsGrid3,
    ],
  },

  {
    number: "03",
    title: "OBJECTS OF DESIRE",
    description: "Architecture.",
    description2: "Interiors. Environments.",
    image: spacesImg,
    side: "left",

    grid: [
      spacesGrid1,
      spacesGrid2,
      spacesGrid3,
    ],
  },

  {
    number: "04",
    title: "ART OF ADORNMENT",
    description: "Details that define",
    description2: "a larger story.",
    image: productsImg,
    side: "right",

    grid: [
      productsGrid1,
      productsGrid2,
      productsGrid3,
    ],
  },

  {
    number: "05",
    title: "MADE TO SELL",
    description: "Flavours.",
    description2: "Textures. Moments.",
    image: foodImg,
    side: "left",

    grid: [
      foodGrid1,
      foodGrid2,
      foodGrid3,
    ],
  },

  {
    number: "06",
    title: "TASTEFULLY YOUR'S",
    description: "Concepts.",
    description2: "Experiments. Beyond.",
    image: creativeImg,
    side: "right",

    grid: [
      creativeGrid1,
      creativeGrid2,
      creativeGrid3,
    ],
  },
  {
    number: "07",
    title: "DYNAMIC STILLS",
    description: "Concepts.",
    description2: "Experiments. Beyond.",
    image: creativeImg,
    side: "right",

    grid: [
      creativeGrid1,
      creativeGrid2,
      creativeGrid3,
    ]
  },
  {
name: "08",
    title: "CULT OF SPACES",
    description: "Concepts.",
    description2: "Experiments. Beyond.",
    image: creativeImg,
    side: "right",

    grid: [
      creativeGrid1,
      creativeGrid2,
      creativeGrid3,
    ]
  },
  {
    number: "09",
    title: "VISUAL NARRATIVES",
    description: "Every expression",
    description2: "tells a story.",
    image: portraitsImg,
    side: "right",

    grid: [
      portraitsGrid1,
      portraitsGrid2,
      portraitsGrid3,
    ]
  },
  {
    number: "10",
    title: "EDITORIAL SPREAD",
    description: "Every expression",
    description2: "tells a story.",
    image: portraitsImg,
    side: "right",

    grid: [
      portraitsGrid1,
      portraitsGrid2,
      portraitsGrid3,
    ]
  }
];


// ============================================
// NAVIGATION
// ============================================

const categories = [
  "CAMPAIGNS",
  "COMMERCIALS",
  "BRAND FILMS",
  "CORPORATE FILMS",
  "DOCUMENTARIES",
  "EVENTS",
  "PODCASTS & INTERVIEWS",
  "SOCIAL AND VERTICAL FILMS",
  "PHOTOGRAPHY CREATIVE",
];

function makeSlug(category) {
  return category
    .toLowerCase()
    .replace(/&/g, "and")
    .replace(/\s+/g, "-");
}


// ============================================
// COMPONENT
// ============================================

function PhotographyCreative() {
const [selectedChapter, setSelectedChapter] = useState(null);
  const goToCategory = (category) => {
    const routes = {
        "CAMPAIGNS": "/campaigns",
        "COMMERCIALS": "/commercials",
        "BRAND FILMS": "/brand-films",
        "CORPORATE FILMS": "/corporate-films",
        "DOCUMENTARIES": "/documentaries",
        "PODCASTS & INTERVIEWS": "/podcasts",
    };

    const route = routes[category];

    if (route) {
        window.location.href = route;
    }
};
if (selectedChapter) {
  return (
    <CinematicChapterPage
      chapter={selectedChapter}
      onBack={() => setSelectedChapter(null)}
    />
  );
}

  return (

    <main className="pc-page">

      <div className="pc-shell">


        {/* =====================================
            INTRO
        ===================================== */}

        <header className="pc-intro">

          <div className="pc-intro-title">
            THE CHAPTER FLOW
          </div>

          <div className="pc-intro-path">
            PHOTOGRAPHY → EDITORIAL SPREAD → GALLERY → VISUAL STORY
          </div>

          <p>
            A rhythm of visuals and storytelling.
            <br />
            Each chapter opens with a bold statement
            <br />
            and unfolds into curated narratives.
            <br />
            Intentional. Immersive. Unforgettable.
          </p>

        </header>


        {/* =====================================
            CHAPTERS
        ===================================== */}

        <section className="pc-chapters">

          {chapters.map((chapter, index) => (

            <div
              className={`pc-chapter pc-${chapter.side}`}
              key={chapter.number}
              data-number={chapter.number}
            >


              {/* =================================
                  FEATURE CARD
              ================================= */}

             <article
  className="pc-feature-card"
  onClick={() => setSelectedChapter(chapter)}
>

                <img
                  src={chapter.image}
                  alt={chapter.title}
                />

                <div className="pc-feature-overlay"></div>


                <div className="pc-feature-content">

                  <span className="pc-number">
                    {chapter.number}
                  </span>

                  <h2>
                    {chapter.title}
                  </h2>

                  <div className="pc-feature-description">

                    <span>
                      {chapter.description}
                    </span>

                    <span>
                      {chapter.description2}
                    </span>

                  </div>


                  <div className="pc-feature-footer">

                    PHOTOGRAPHY & CREATIVE

                    <br />

                    VOLUME {chapter.number}

                  </div>

                </div>

              </article>


              {/* =================================
                  EDITORIAL COLLAGE
              ================================= */}

              <article className="pc-editorial-card">

                <div className="pc-editorial-paper">

                  <div className="pc-editorial-copy">

                    <span className="pc-editorial-small">
                      BEHIND EVERY FRAME
                    </span>

                    <h3>

                      {index === 0 &&
                        "BEYOND A SINGLE FRAME"}

                      {index === 1 &&
                        "EVERY EXPRESSION"}

                      {index === 2 &&
                        "SPACE TELLS A STORY"}

                      {index === 3 &&
                        "DETAILS MATTER"}

                      {index === 4 &&
                        "A TASTE OF MOMENTS"}

                      {index === 5 &&
                        "IDEAS WITHOUT LIMITS"}

                    </h3>

                    <p>

                      {index === 0 &&
                        "People give meaning to places. Every moment becomes part of a larger visual story."}

                      {index === 1 &&
                        "A portrait is more than a face. It is emotion, personality and presence."}

                      {index === 2 &&
                        "Spaces shape the way we experience the world, from architecture to interiors."}

                      {index === 3 &&
                        "The smallest details often create the strongest visual impression."}

                      {index === 4 &&
                        "Food is texture, colour, craft and emotion captured in a single frame."}

                      {index === 5 &&
                        "Concepts, experiments and unexpected ideas transformed into visual stories."}

                    </p>


                    <div className="pc-paper-footer">

                      THE CHAPTER EDIT

                      <span>
                        VOL. {chapter.number}
                      </span>

                    </div>

                  </div>


                  <div className="pc-editorial-image">

                    <img
                      src={chapter.grid[0]}
                      alt=""
                    />

                  </div>

                </div>


                {/* COLLAGE SIDE */}

                <div className="pc-collage">

                  {chapter.grid.map((image, imageIndex) => (

                    <div
                      className="pc-collage-image"
                      key={imageIndex}
                    >

                      <img
                        src={image}
                        alt=""
                      />

                    </div>

                  ))}

                </div>

              </article>


            </div>

          ))}

        </section>


        {/* =====================================
            BOTTOM NAVIGATION
        ===================================== */}

        <nav className="pc-navigation">

          <button
            className="pc-nav-arrow"
            onClick={() =>
              goToCategory(
                categories[categories.length - 1]
              )
            }
          >
            ←
          </button>


          <div className="pc-category-list">

            {categories.map((category) => (

              <button
                key={category}
                className="pc-category"
                onClick={() =>
                  goToCategory(category)
                }
              >

                {category}

              </button>

            ))}

          </div>


          <button
            className="pc-nav-arrow"
            onClick={() =>
              goToCategory(categories[0])
            }
          >
            →
          </button>

        </nav>

      </div>

    </main>

  );
}


export default PhotographyCreative;